import { SubrentalEntryDetailPrintModel } from "./subrental-entry-detail-print.model";

export class SubrentalEntryPrintModel {
  inventoryEntryId: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  branchCode: string = '';
  branchName: string = '';
  address: string = '';
  phone: string = '';
  consecutive: string = '';
  dateEntry: Date = new Date();
  inventoryEntryStateId: number = 0;
  inventoryEntryState: string = '';
  remission?: string = '';
  observation?: string = '';
  transportValue: number = 0;
  subrentalEntryDetails: SubrentalEntryDetailPrintModel[] = [];

}